<div class="modal-container">

  <!-- Header -->
  <div class="modal-header">
    <h2 class="modal-title">Training Session Details</h2>
    <button class="close-btn" mat-icon-button (click)="dialogRef.close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <!-- Content -->
  <div class="modal-content" mat-dialog-content>
    <div class="detail-grid">
      <div class="detail-row" *ngIf="cardData?.trainingName">
        <span class="label">Training Title</span>
        <span class="value">MCT Onboarding Experience</span>
      </div>
      <div class="detail-row" *ngIf="cardData?.sessionDate">
        <span class="label">Session Date</span>
        <span class="value">{{ cardData.sessionDate }}</span>
      </div>
      <div class="detail-row" *ngIf="cardData?.trainingTiming">
        <span class="label">Timing</span>
        <span class="value">{{ cardData.trainingTiming }} {{cardData.timezone}}</span>
      </div>
      <div class="detail-row" *ngIf="cardData?.instructorName">
        <span class="label">Instructor</span>
        <span class="value">{{ cardData.instructorName }}</span>
      </div>
      <div class="detail-row" *ngIf="cardData?.location">
        <span class="label">Location</span>
        <span class="value">Virtual</span>
      </div>
       <div class="detail-row" *ngIf="cardData?.location">
        <span class="label">Language</span>
        <span class="value">{{ cardData.language }}</span>
      </div>
       <div class="detail-row" >
        <span class="label">Dates</span>
        <div class="value">
          <div>{{ cardData.startDate | date:'EEEE, MMMM d, y' }}</div>
          <div *ngIf="cardData?.endDate && cardData.endDate !== cardData.startDate">
             - {{ cardData.endDate | date:'EEEE, MMMM d, y' }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-instructions">
    <p>
      Please review the details above before continuing to payment. 
      As a reminder, AB-730 or AB-731 are required prerequisites for this course, 
      and you will be asked to provide evidence of your certification as part of this course.
      By enrolling, you agree to attend and actively participate in the full three-day course with your camera on. 
      Once payment is completed, enrolments cannot be modified or canceled.
    </p>
  </div>

  <mat-divider></mat-divider>

  <!-- Footer -->
  <div class="modal-footer" mat-dialog-actions>
    <button mat-stroked-button class="cancel-btn" (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button class="continue-btn" (click)="onContinue()">Continue</button>
  </div>

</div>